import { render, staticRenderFns } from "./square.vue?vue&type=template&id=da50dcd6&scoped=true"
import script from "./square.vue?vue&type=script&lang=js"
export * from "./square.vue?vue&type=script&lang=js"
import style0 from "./square.vue?vue&type=style&index=0&id=da50dcd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da50dcd6",
  null
  
)

export default component.exports